import { FocusStyleManager } from '@blueprintjs/core';
import React from 'react';
import MainRouter from './MainRouter';

import './app.css';

export default function App() {
  React.useEffect(() => {
    FocusStyleManager.onlyShowFocusOnTabs();
  }, []);

  return (
    <>
      <MainRouter />
      <div style={{ display: 'none' }}></div>
    </>
  );
}
